// src/components/BoardOfEd/components/Program3400.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_3400_CONFIG = {
  fullName: "BENEFITS & SUBSTITUTES",
  docId: "3400",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsClassroomSubsParas",
      label: "Positions – Classroom / Subs (FT Paras)",
      valueType: "count",
      sources: [{ block: "Positions", key: "Classroom/Subs (FT Paras)" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesSubsAdmin",
      label: "Salaries – Substitutes (Administrator)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Substitutes (Administrator)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSubsTeacher",
      label: "Salaries – Substitutes (Teacher)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Substitutes (Teacher)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSubsNurse",
      label: "Salaries – Substitutes (Nurse)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Substitutes (Nurse)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesClassroomSubsParas",
      label: "Salaries – Classroom / Subs (FT Paras)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Classroom/Subs (FT Paras)" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesIllnessCoverageClassified",
      label: "Salaries – Illness Coverage (Classified Staff)",
      valueType: "currency",
      sources: [
        {
          block: "Salaries",
          key: "Illness Coverage (Classified Staff)",
        },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesContractualRetirementResign",
      label: "Salaries – Contractual Retirement/Resign",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Contractual Retirement/Resign" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSabbatical",
      label: "Salaries – Sabbatical",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Sabbatical" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesNegotiations",
      label: "Salaries – Negotiations",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Negotiations" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesNonAffiliatedAdjustments",
      label: "Salaries – Non-Affiliated Adjustments",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Non-Affiliated Adjustments" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesDegreeChanges",
      label: "Salaries – Degree Changes",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Degree Changes" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesPersonnelTurnover",
      label: "Salaries – Personnel Turnover",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Personnel Turnover" }],
      group: "salaries",
      defaultVisible: false,
    },

    // EMPLOYEE BENEFITS
    {
      key: "benefitsDisabilityInsurance",
      label: "Disability Insurance",
      valueType: "currency",
      sources: [{ block: "Employee Benefits", key: "Disability Insurance" }],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsLifeInsurance",
      label: "Life Insurance",
      valueType: "currency",
      sources: [{ block: "Employee Benefits", key: "Life Insurance" }],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsHealthInsurance",
      label: "Health Insurance",
      valueType: "currency",
      sources: [{ block: "Employee Benefits", key: "Health Insurance" }],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsOPEB",
      label: "OPEB",
      valueType: "currency",
      sources: [{ block: "Employee Benefits", key: "OPEB" }],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsRetirementClassified",
      label: "Retirement / Classified",
      valueType: "currency",
      sources: [{ block: "Employee Benefits", key: "Retirement/Classified" }],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsSocialSecurityEmployerShare",
      label: "Social Security / Employer Share",
      valueType: "currency",
      sources: [
        {
          block: "Employee Benefits",
          key: "Social Security/Employer Share",
        },
      ],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsWorkersCompensation",
      label: "Workers Compensation",
      valueType: "currency",
      sources: [
        { block: "Employee Benefits", key: "Workers Compensation" },
      ],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsUnemploymentCompensation",
      label: "Unemployment Compensation",
      valueType: "currency",
      sources: [
        { block: "Employee Benefits", key: "Unemployment Compensation" },
      ],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsEmplMandatedScreening",
      label: "Empl. Mandated Screening",
      valueType: "currency",
      sources: [
        { block: "Employee Benefits", key: "Empl. Mandated Screening" },
      ],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsProfessionalTechnicalServices",
      label: "Professional Technical Services",
      valueType: "currency",
      sources: [
        {
          block: "Employee Benefits",
          key: "Professional Technical Services",
        },
      ],
      group: "benefits",
      defaultVisible: false,
    },
    {
      key: "benefitsEmployeeRelations",
      label: "Employee Relations",
      valueType: "currency",
      sources: [{ block: "Employee Benefits", key: "Employee Relations" }],
      group: "benefits",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsClassroomSubsParas",

        // Salaries
        "salariesSubsAdmin",
        "salariesSubsTeacher",
        "salariesSubsNurse",
        "salariesClassroomSubsParas",
        "salariesIllnessCoverageClassified",
        "salariesContractualRetirementResign",
        "salariesSabbatical",
        "salariesNegotiations",
        "salariesNonAffiliatedAdjustments",
        "salariesDegreeChanges",
        "salariesPersonnelTurnover",

        // Employee Benefits
        "benefitsDisabilityInsurance",
        "benefitsLifeInsurance",
        "benefitsHealthInsurance",
        "benefitsOPEB",
        "benefitsRetirementClassified",
        "benefitsSocialSecurityEmployerShare",
        "benefitsWorkersCompensation",
        "benefitsUnemploymentCompensation",
        "benefitsEmplMandatedScreening",
        "benefitsProfessionalTechnicalServices",
        "benefitsEmployeeRelations",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsClassroomSubsParas: { minWidth: "180px" },

        // Salaries
        salariesSubsAdmin: { minWidth: "180px" },
        salariesSubsTeacher: { minWidth: "170px" },
        salariesSubsNurse: { minWidth: "160px" },
        salariesClassroomSubsParas: { minWidth: "170px" },
        salariesIllnessCoverageClassified: { minWidth: "220px" },
        salariesContractualRetirementResign: { minWidth: "200px" },
        salariesSabbatical: { minWidth: "110px" },
        salariesNegotiations: { minWidth: "110px" },
        salariesNonAffiliatedAdjustments: { minWidth: "180px" },
        salariesDegreeChanges: { minWidth: "160px" },
        salariesPersonnelTurnover: { minWidth: "160px" },

        // Benefits
        benefitsDisabilityInsurance: { minWidth: "120px" },
        benefitsLifeInsurance: { minWidth: "120px" },
        benefitsHealthInsurance: { minWidth: "120px" },
        benefitsOPEB: { minWidth: "90px" },
        benefitsRetirementClassified: { minWidth: "120px" },
        benefitsSocialSecurityEmployerShare: { minWidth: "160px" },
        benefitsWorkersCompensation: { minWidth: "120px" },
        benefitsUnemploymentCompensation: { minWidth: "150px" },
        benefitsEmplMandatedScreening: { minWidth: "150px" },
        benefitsProfessionalTechnicalServices: { minWidth: "160px" },
        benefitsEmployeeRelations: { minWidth: "100px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsClassroomSubsParas",

        // Salaries
        "salariesSubsAdmin",
        "salariesSubsTeacher",
        "salariesSubsNurse",
        "salariesClassroomSubsParas",
        "salariesIllnessCoverageClassified",
        "salariesContractualRetirementResign",
        "salariesSabbatical",
        "salariesNegotiations",
        "salariesNonAffiliatedAdjustments",
        "salariesDegreeChanges",
        "salariesPersonnelTurnover",

        // Employee Benefits
        "benefitsDisabilityInsurance",
        "benefitsLifeInsurance",
        "benefitsHealthInsurance",
        "benefitsOPEB",
        "benefitsRetirementClassified",
        "benefitsSocialSecurityEmployerShare",
        "benefitsWorkersCompensation",
        "benefitsUnemploymentCompensation",
        "benefitsEmplMandatedScreening",
        "benefitsProfessionalTechnicalServices",
        "benefitsEmployeeRelations",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsClassroomSubsParas: { minWidth: "180px" },

        // Salaries
        salariesSubsAdmin: { minWidth: "180px" },
        salariesSubsTeacher: { minWidth: "170px" },
        salariesSubsNurse: { minWidth: "160px" },
        salariesClassroomSubsParas: { minWidth: "170px" },
        salariesIllnessCoverageClassified: { minWidth: "220px" },
        salariesContractualRetirementResign: { minWidth: "200px" },
        salariesSabbatical: { minWidth: "110px" },
        salariesNegotiations: { minWidth: "110px" },
        salariesNonAffiliatedAdjustments: { minWidth: "180px" },
        salariesDegreeChanges: { minWidth: "160px" },
        salariesPersonnelTurnover: { minWidth: "160px" },

        // Benefits
        benefitsDisabilityInsurance: { minWidth: "120px" },
        benefitsLifeInsurance: { minWidth: "120px" },
        benefitsHealthInsurance: { minWidth: "120px" },
        benefitsOPEB: { minWidth: "90px" },
        benefitsRetirementClassified: { minWidth: "120px" },
        benefitsSocialSecurityEmployerShare: { minWidth: "160px" },
        benefitsWorkersCompensation: { minWidth: "120px" },
        benefitsUnemploymentCompensation: { minWidth: "150px" },
        benefitsEmplMandatedScreening: { minWidth: "150px" },
        benefitsProfessionalTechnicalServices: { minWidth: "160px" },
        benefitsEmployeeRelations: { minWidth: "100px" },
      },
    },
  ],
};

export function Program3400(props) {
  return (
    <ProgramBudget programId="3400" config={PROGRAM_3400_CONFIG} {...props} />
  );
}
